<template id="template-select">
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    class="text-left"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :isHidden="isHidden"
      :label="label"
      v-on:toggle-field="showSettings = !showSettings"
      v-on:collapse-field="collapse = !collapse"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
    />
    <!-- preview tab -->
    <b-collapse
      v-show="JSON.parse(!fieldData.isHidden) || !isPreview"
      :class="isPreview ? 'mt-0' : 'mt-5'"
      id="collapse-1"
      v-model="collapse"
    >
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button
            v-if="fieldData.isConditional == '1' && !isPreview"
            variant="outline-dark"
            disabled
            title="This field is hidden by default and will display bt is controlled element"
          >
            <font-awesome-icon icon="eye-slash" />
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-left">
          <b-form-group
            :id="fieldData.id"
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :description="fieldData.helperText[selectedLanguage]"
            :invalid-feedback="fieldData.validationMessage[selectedLanguage]"
          >
            <label>
              <span
                v-if="
                  fieldData.validation && fieldData.validation.required == 1
                "
                class="required-span"
                >*</span
              >
              {{
                form1.enableSectionFieldEnumeration == 1
                  ? sectionIndex + 1 + "." + (fieldIndex + 1)
                  : ""
              }}
              {{ label ? label : fieldData.label[selectedLanguage] }}
            </label>

            <!-- :reduce="name => name.name" -->
            <v-select
              :id="fieldData.id"
              :disabled="isDisabled == 1"
              :searchable="fieldData.configuration.isLiveSearchable"
              :clearable="fieldData.configuration.isClearable"
              :multiple="fieldData.configuration.isMultipleSelect"
              label="name"
              :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
              :options="renderOptions"
              :value="selectedCountry1"
              @input="checkCondition"
            >
              <template slot="option" slot-scope="option">
                <country-flag
                  v-if="option.icon"
                  :country="option.icon"
                  size="small"
                />
                <span>{{ "&nbsp;" + option.name }}</span>
              </template>
            </v-select>
            <label
              v-if="
                fieldData.validation &&
                  fieldData.validation.required == 1 &&
                  !selectedCountry1 &&
                  isFocus
              "
              :class="
                $store.state.rightAlign
                  ? 'text-right text-danger'
                  : 'text-left text-danger'
              "
              >{{ fieldData.validationMessage[selectedLanguage] }}</label
            >
          </b-form-group>
        </b-col>
      </b-row>
      <!-- advance settings tab -->

      <b-modal
        cancel-title="Close"
        @ok="onSaveData"
        ok-title="save"
        size="xl"
        v-model="showSettings"
        title="Select Picker Advanced Settings"
      >
        <AdvanceSelectSettings
          v-if="showSettings"
          :fieldData="fieldData"
          v-on:toggle-field="showSettings = !showSettings"
          v-on:update-form-settings="getData"
          @label-text="label = $event"
          @helper-text="helperText = $event"
          :sectionIndex="sectionIndex"
        />
      </b-modal>
    </b-collapse>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
//import VSelect from "@alfsnd/vue-bootstrap-select";
import vSelect from "vue-select";
import MenuButtons from "../menuButtons";
import AdvanceSelectSettings from "../advanceRadioSettingsComponent.vue";
// import CountryCodes from "../../utils/countryCodes.json";
import CountryCodes from "../../utils/countryCodesRiskScore.json";
import { mapGetters, mapState, mapMutations } from "vuex";
import { EventBus } from "@/event-bus.js";
import { ValidateSections } from "../../helpers";

export default {
  name: "CountriesSelectGroup",
  components: {
    MenuButtons,
    AdvanceSelectSettings,
    vSelect,
  },
  data() {
    return {
      isHidden: false,
      isFocus: false,
      condition: {},
      showSettings: false,
      collapse: true,
      label: undefined,
      helperText: undefined,
      selectedListTypeIndex: 0,
      isRequired: 1,
      name: "",
      renderOptions: CountryCodes[0].countries,
      selectedCountry: [],
      selectedCountry1: null,
      isIndigenous: 0,
    };
  },
  created() {
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (value == "progress") {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
      } else {
        if (
          this.fieldData.validation &&
          this.fieldData.validation.required == 1
        ) {
          if (!this.selectedCountry1) {
            this.isFocus = true;
            this.$store.state.validFields = false;
            this.fieldData.isInValid = true;
          } else {
            this.$store.state.validFields = true;
            this.fieldData.isInValid = false;
          }
        }
      }
    });

    EventBus.$on("OnInvalidFieldCatch", (inValidData) => {
      // console.log("OnInvalidFieldCatch radio", inValidData, this.fieldData.id);
      document
        .getElementById(inValidData.elementId)
        .scrollIntoView({ behavior: "smooth" });
    });

    EventBus.$on("onRestoreCountry", (e) => {
      if (e.isHiddenElement == 1 && e.elementId === this.fieldData.id) {
        (this.selectedCountry1 = null), (this.fieldData.isInValid = false);
        this.fieldData.validation.required = 0;
      }
    });
  },
  
  computed: {
    ...mapGetters(["form1", "selectedLanguage"]),
    ...mapState(["toggleAllCoppalse", "userFormSubmitArray"]),
  },

  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    },

    selectedListTypeIndex(val) {
      this.renderOptions = CountryCodes[val].countries;
    },
  },

  mounted() {
    this.isRequired = this.fieldData.validation.required;
    if (
      this.fieldData.selectedListTypeIndex &&
      this.fieldData.selectedListTypeIndex.value == 1
    ) {
      this.sectionCondition();
    }
    if (
      this.fieldData.selectedListTypeIndex &&
      this.fieldData.selectedListTypeIndex.value
    ) {
      let index = parseInt(this.fieldData.selectedListTypeIndex.value);
      this.renderOptions = CountryCodes[index].countries;
    }

    // let getOptions = this.fieldData.options;
    // getOptions.map(option => {
    // 	let code = option || "No Value Set";
    // 	this.renderOptions.push(code);
    // });
    if (
      this.$route.name == "userform" ||
      this.$route.name == "EmployeeUserFormPage" ||
      this.$route.name == "EmployeeComplaintFormPage" ||
      this.$route.name == "ViewComplaints"
    ) {
      this.setFieldValue();
    }
  },

  methods: {
    ...mapMutations(["TOGGLE_LOADER"]),
    getData(data) {
      this.$emit("update-form-settings", data);
    },

    checkCondition(value) {
      console.log("checkCondition", value);
      this.selectedCountry1 = value;
      this.isFocus = false;
      this.$store.state.validFields = true;
      this.fieldData.isInValid = false;
      this.setValue(value);
      let findIndigious = value.find((ind) => ind.indigenious);
      // console.log("findIndigious", findIndigious);
      if (findIndigious) {
        EventBus.$emit("refreshProductList", value.length);
      }
      this.restoreSecfourCountryScore();
    },

    restoreSecfourCountryScore() {
      let sections = this.form1.formSection;
      let sectionFour = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] == "Business Operations"
      );

      this.$store.state.userFormSubmitArray.find((s4) => {
        if (sectionFour.id == s4.sectionId) {
          for (let ele of s4.elements) {
            if (ele.risk == "Low" && ele.score == 13) {
              ele.score = 0;
            }
          }
        }
      });
    },

    sectionCondition(selectedCtr) {
      let indigenousCountr = null;
      // console.log("selectedCtr", this.selectedCountry1);
      // for section conditions
      let sections = this.form1.formSection;
      let elements = this.form1.formSection[this.sectionIndex].formElements;

      let indigenousSection1 = sections.find(
        (sec) => sec.sectionTitle[this.selectedLanguage] == "Indigenous People"
      );

      let sectionSeven = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] ==
          "Services/Goods (Additional Question)"
      );

      let sectionSix = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] == "Details of Services/Goods"
      );

      let sectionFour = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] == "Business Operations"
      );

      if (this.selectedCountry1 && this.selectedCountry1.length) {
        indigenousCountr = this.selectedCountry1.find(
          (ctr) => ctr.indigenious == 1
        );
      }
      if (
        this.form1.formSection[this.sectionIndex].sectionTitle[
          this.selectedLanguage
        ] == "Business Operations"
      ) {
        if (indigenousCountr) {
          // if (indigenousSection1) {
          this.isIndigenous = 1;
          console.log("is Hidden false inside country componenet");
          let sec = this.form1.formSection[indigenousSection1.index];
          Object.assign(sec, (sec.isHidden = false));
          EventBus.$emit(
            "sectionCheck",
            this.form1.formSection[indigenousSection1.index]
          );
          this.form1.formSection[indigenousSection1.index].formElements.map(
            (ele) => {
              // ele.validation.required = 1;
              // ele.isInValid = true;
            }
          );
        } else {
          console.log("is Hidden true inside country componenet");
          this.isIndigenous = 0;
          let sec = this.form1.formSection[indigenousSection1.index];
          Object.assign(sec, (sec.isHidden = true));
          EventBus.$emit(
            "sectionCheck",
            this.form1.formSection[indigenousSection1.index]
          );
          this.form1.formSection[indigenousSection1.index].formElements.map(
            (ele) => {
              ele.validation.required = 0;
              ele.isInValid = false;
              let foundEle = this.$store.state.userFormSubmitArray.find(
                (ele1) => ele1.elementId == ele.id
              );
              // console.log("eeeee", foundEle)
              if (foundEle) {
                // foundEle.elements = [];
              }
            }
          );
          // this.form1.formSection[indigenousSection.index].isHidden = false;
        }
      }
      // }

      // this.checkExistanceCountry(indigenousSection1);
    },

    checkExistanceCountry(indigenousSection1) {
      let sections = this.form1.formSection;
      let compareSection = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] == "Business Operations"
      );

      let compareFromSection = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] == "Details of Services/Goods"
      );

      // console.log("compareFromSection", compareFromSection)

      let ff = compareFromSection.formElements.find(
        (a) => a.inputType == "countries"
      );
      // console.log("ff", ff)

      let eleNew = this.$store.state.userFormSubmitArray.find(
        (ele) => ele.elementId == compareSection.formElements[0].id
      );

      if (eleNew && eleNew.elements.length) {
        console.log("checkExistanceCountry == true");
        let highestScore = eleNew.dataAttributes.find(
          (atr) => atr.dataAttributeKey == "highest_score"
        );
        if (highestScore) {
          highestScore.dataAttributeValue = 0;
        }
      }
    },

    setFieldValue() {
      this.$store.state.getUserFormSubmitArray.length &&
        this.$store.state.getUserFormSubmitArray.map((a, index) => {
          if (a && a.elementId && a.elements && a.elements.length) {
            if (a.elementId === this.fieldData.id) {
              a.elements.map((el) => {
                return (
                  (this.selectedCountry1 = el.postValue || null),
                  (this.isIndigenous = el.isIndigenous || 0)
                );
              });
              this.sectionCondition();
            }
          }
        });
    },

    setValue(e) {
      // console.log("userFormSubmitArray 1", this.userFormSubmitArray);
      const registerData = _.clone(this.$store.state.registerData);
      // // console.log("e", this.selectedCountry1)
      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        // this.fieldData.selected = this.selectedCountry;
        // let aa = [];
        // this.fieldData.selected.map(c => {
        // 	aa.push(c.name);
        // });
        // // console.log("eeeee", e);
        if (e) {
          registerData[this.fieldData.id] = e;
        } else {
          delete registerData[this.fieldData.id];
        }
        this.$store.state.registerData = registerData;

        // main calculations :p
        const numkeys = Object.keys(registerData).length;
        // const sectionLength = this.form1.formSection.length > 1 ? this.form1.formSection[this.sectionIndex].formElements.length : 1
        this.$store.state.progressValue = numkeys;

        if (
          this.fieldData.configuration &&
          this.fieldData.configuration.isMultipleSelect &&
          this.selectedCountry1.length
        ) {
          this.userFormSubmitArray.find((a, index) => {
            if (a.elementId === this.fieldData.id) {
              let xMax = Math.max(
                ...Array.from(this.selectedCountry1, (o) => o.riskScore)
              ); // to calculate max risk score
              let maxXObject = this.selectedCountry1.find(
                (o) => o.riskScore === xMax
              );
              a.elements[0] = {
                postValue: this.selectedCountry1,
                score: maxXObject.riskScore || 0,
                risk: maxXObject.risk || null,
                isIndigenous: this.isIndigenous,
                postName:
                  (this.fieldData.attributes &&
                    this.fieldData.attributes.postName) ||
                  "postNameCountries",
              };
              this.sectionCondition(this.selectedCountry1);
            }
          });
        } else if (this.selectedCountry1 && this.selectedCountry1.name) {
          let aa = [];
          aa.push(this.selectedCountry1);
          this.userFormSubmitArray.find((a, index) => {
            if (a.elementId === this.fieldData.id) {
              // console.log("this.this.selectedCountry1", this.selectedCountry1)
              // console.log("this.selectedListTypeIndex", this.selectedListTypeIndex)

              a.elements[0] = {
                postValue: aa,
                score: this.selectedCountry1.riskScore || null,
                risk: this.selectedCountry1.risk || null,
                isIndigenous: this.isIndigenous,
                postName:
                  (this.fieldData.attributes &&
                    this.fieldData.attributes.postName) ||
                  "postNameCountries",
              };
            }
          });
        }
        this.sectionCondition();
      }
    },

    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
      this.selectedListTypeIndex =
        (this.fieldData.selectedListTypeIndex &&
          this.fieldData.selectedListTypeIndex.value) ||
        0;
    },
  },

  validations: {
    selected: {
      required,
    },
  },

  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>
<style>
.v-select.disabled .v-select-toggle[data-v-138dff1d] {
  background-color: white !important;
}
</style>
